import React from 'react'
import { Avatar, Button, Skeleton, Typography, useGAEvent } from '..'
import { generateBGColorClassName } from '../../../utils/randomColor'
import { BreifCaseIconWhite, LoginBlackIcon } from '../../../theme/icons2'
import { Tooltip } from 'flowbite-react'
import { useLazyQuery } from '@apollo/client'
import { LOGIN_INTO_CLIENT_PORTAL } from '../../../grapghQl/queries/clients'
import { useNavigate } from 'react-router-dom'
import { customEvents } from '../../../utils/customEvents'
import { useToasts } from '../../Toast'
import { useIntl } from 'react-intl'

export const ClientSearch = ({ clientsData = [], loading = false, closeFilterMenu = () => null,
    saveSearchHistory = () => null, }) => {
    return (
        <div className='p-3 flex flex-col gap-3'>
            <Typography variant="base" className="text-secondary-400 font-medium" text={`All Clients (${clientsData?.length || 0})`} />
            <div className={`grid grid-cols-1 md:grid-cols-2 gap-3 `}>
                {loading ?
                    Array.from({ length: 4 }, (_, i) => i + 1)?.map(loader => <Loader key={loader} />) :
                    !!clientsData?.length && clientsData?.map((client, index) =>
                        <SingleClient index={index} closeFilterMenu={closeFilterMenu}
                            saveSearchHistory={saveSearchHistory}
                            {...client} key={client?._id} />)}
            </div>
            {!loading && !clientsData?.length && <div className='flex justify-center h-[8vh] items-center w-full'>
                <Typography variant="sm" text="No Clients Found" className="text-secondary-400" />
            </div>}
        </div>
    )
}

export const SingleClient = ({ name = '', _id = null, closeFilterMenu = () => null, index = 0,
    saveSearchHistory = () => null, }) => {
    const navigate = useNavigate();
    const sendGAEvent = useGAEvent();
    const { setToastMessage } = useToasts();
    const intl = useIntl() || {}
    const { messages = {} } = intl || { messages: {} };
    const [logintoClientAccount, { loading }] = useLazyQuery(LOGIN_INTO_CLIENT_PORTAL);

    const onClientView = async () => {
        closeFilterMenu();
        sendGAEvent(customEvents.GA_CLIENTS_VIEW);
        await saveSearchHistory({ type: "client", globalSearchLogId: _id })
        navigate(`/clients/details?client_id=${_id}&tab=manage_assignee`);
    }

    const handleLogin = async () => {
        try {
            const { data } = await logintoClientAccount({
                variables: { clientId: _id }
            })
            const { clientUrl } = data || { clientUrl: "" }
            sendGAEvent(customEvents.GA_CLIENTS_LOGIN)
            if (data && "clientUrl" in data) {
                clientUrl.includes('undefined') ? setToastMessage({
                    message: messages?.['CLIENT.LOGIN.FAILES.WITH.NO_URL.MESSAGE'],
                    variant: "error"
                }) : clientUrl ? window.open(clientUrl) : setToastMessage({
                    message: messages?.['CLIENT.LOGIN.ERROR.MESSAGE'],
                    variant: "error"
                })
            }
        } catch (error) {
            setToastMessage({ message: error?.message, variant: "error" })
        }
    }

    return (<div className='flex gap-3 items-center w-full my-1 justify-between'>
        <span onClick={onClientView}>
            <Avatar alt={name} className={`${generateBGColorClassName(index)} cursor-pointer`}
                src={<BreifCaseIconWhite className="m-auto h-[20px] w-[20px] flex justify-center items-center" />} />
        </span>
        <div className='w-[80%]'>
            <Tooltip placement="bottom" content={name}>
                <Typography variant="base" onClick={onClientView}  
                    className="text-secondary-400 cursor-pointer text-left hover:text-secondary-600  line-clamp-2" text={name} />
            </Tooltip>
        </div>
        <Button variant="tertiary" onClick={handleLogin} loader={loading}
            loaderText={''} disabled={loading} className="w-fit h-fit m-0 p-0" text="" icon={
                <Tooltip placement="bottom" content={"Login"}>
                    <LoginBlackIcon />
                </Tooltip>
            } />

    </div>)
}

const Loader = () => (
    <div className='flex gap-3 items-center w-full my-1'>
        <Skeleton parentClassName="w-fit" length={1} className="h-[2.7rem] w-[2.7rem] rounded-full" />
        <div className='w-full flex flex-col gap-2'>
            <Skeleton length={1} className="h-5 w-full rounded-md" />
            <Skeleton length={1} className="h-3 w-full rounded-md" />
        </div>
        <Skeleton parentClassName="w-fit" length={1} className="h-8 w-6 rounded-md" />
    </div>
)